import { Helmet } from 'react-helmet-async';
import useHearingCouncilsLink from './use-hearing-councils-links';
import { Card, Divider, Grid, Skeleton, Stack } from '@mui/material';
import AppTableToolbar from 'src/components/table/AppTableToolbar';
import AddSessionHearingCouncilDialog from 'src/sections/dialogs/add/AddSessionHearingCouncilDialog';
import EmptyContent from 'src/components/empty-content';
import HearingCouncilsLinkCard from './hearing_council_link_card';

const HearingCouncilsLink = () => {
  const { isLoading, t, query, setQuery, handleSearch, data, addSessionDialog } =
    useHearingCouncilsLink();

  const viewComponent = (
    <>
      <Card sx={{ p: 2 }}>
        <Stack spacing={2}>
          <AppTableToolbar
            handleSearch={handleSearch}
            setQuery={setQuery}
            tableName=""
            search={query.search!}
            buttons={[
              {
                onClick: addSessionDialog.onTrue,
                label: t('tables.sessionsHearingCouncils.addNew'),
                // permissionName: AppPermissions.Link_CREATE,
              },
            ]}
          />
          <Divider />
          <Grid container columnSpacing={{ md: 2, xs: 0 }} rowSpacing={2}>
            {!isLoading ? (
              data?.hearing_council_links?.length == 0 ? (
                <EmptyContent filled title={t('tables.empty')} />
              ) : (
                data?.hearing_council_links?.map((hearing_council_link) => (
                  <Grid
                    key={hearing_council_link.id}
                    item
                    md={6}
                    xs={12}
                    display="flex"
                    width="100%"
                  >
                    <HearingCouncilsLinkCard hearing_council_link={hearing_council_link} />
                  </Grid>
                ))
              )
            ) : (
              [...Array(data?.hearing_council_links.length)].map((i, index) => (
                <Grid key={index} item md={4} xs={12} display="flex" width="100%">
                  <Skeleton
                    variant="rectangular"
                    sx={{
                      width: '100%',
                      height: 118,
                      borderRadius: 2,
                    }}
                  />
                </Grid>
              ))
            )}
          </Grid>
        </Stack>
      </Card>
    </>
  );

  return (
    <>
      <Helmet>
        <title>{t('titles.showSessions')}</title>
      </Helmet>
      {viewComponent}
      <AddSessionHearingCouncilDialog
        open={addSessionDialog.value}
        onClose={addSessionDialog.onFalse}
      />
    </>
  );
};

export default HearingCouncilsLink;
